module.exports = __webpack_public_path__ + "img/apple-pay.de3a2d8e.svg";